{
  "titles": {
    "error": "Error",
    "success": "Success",
    "warning": "Warning",
    "notice": "Notice"
  },
  "copied": "Copied to clipboard",
  "saved": "Saved successfully.",
  "deleted": "Deleted successfully."
}
